const localStorageManager = {
	get<T>(name: string): T | null {
		const item = localStorage.getItem(name);

		if (!item) {
			return null;
		}

		try {
			return JSON.parse(item) as T;
		} catch (error) {
			console.error(`Error parsing localStorage item: ${name}`, error);
			return null;
		}
	},

	set(name: string, data: unknown): void {
		try {
			localStorage.setItem(name, JSON.stringify(data));
		} catch (error) {
			console.error(`Error saving to localStorage item: ${name}`, error);
		}
	},

	remove(name: string): void {
		localStorage.removeItem(name);
	},
};

export default localStorageManager;
